// ---- M13: felszerelés (fegyvertípus + védelmi modul) ----
// A harci számok a packages/simulation/src/loadout.ts-ben vannak; itt a közös azonosítók, nevek, árszorzók
// (a szerver ezzel számol, a kliens ezt jeleníti meg).

export type WeaponType = 'kinetic' | 'beam' | 'missile';
export type DefenseModule = 'none' | 'plating' | 'shield' | 'pointdef' | 'ecm';

export const WEAPON_TYPES: readonly WeaponType[] = ['kinetic', 'beam', 'missile'];
export const DEFENSE_MODULES: readonly DefenseModule[] = ['none', 'plating', 'shield', 'pointdef', 'ecm'];
export const DEFAULT_WEAPON: WeaponType = 'kinetic';
export const DEFAULT_MODULE: DefenseModule = 'none';

export const isWeaponType = (v: unknown): v is WeaponType => typeof v === 'string' && (WEAPON_TYPES as readonly string[]).includes(v);
export const isDefenseModule = (v: unknown): v is DefenseModule => typeof v === 'string' && (DEFENSE_MODULES as readonly string[]).includes(v);

export interface LoadoutInfo {
  name: string;
  description: string;
  /** Fém- és energiaár szorzója az alap hajóárhoz képest. */
  costFactor: number;
  /** A feloldó technológia azonosítója (null = alapból elérhető). */
  tech: string | null;
}

export const WEAPON_INFO: Record<WeaponType, LoadoutInfo> = {
  kinetic: { name: 'Kinetikus ágyú', description: 'Alapfegyver. Erős a pajzsmodulok ellen, gyenge a páncélozással szemben.', costFactor: 1, tech: null },
  beam: { name: 'Energiasugár', description: 'Rövidebb hatótáv, jobb követés. Átüti a páncélozást, a pajzsmodul felfogja.', costFactor: 1.1, tech: 'beam_weapons' },
  missile: { name: 'Rakéta', description: 'Nagyobb hatótáv, de a pontvédelem és az ECM szinte semlegesíti.', costFactor: 1.25, tech: 'missile_tubes' },
};

export const MODULE_INFO: Record<DefenseModule, LoadoutInfo> = {
  none: { name: 'Nincs modul', description: 'Nincs védelmi modul, semmilyen fegyver ellen sem erősebb vagy gyengébb.', costFactor: 1, tech: null },
  plating: { name: 'Páncélozás', description: '+1 páncél, a kinetikus lövedékek 40%-át elnyeli; az energiasugárra érzékeny.', costFactor: 1.15, tech: 'reactive_plating' },
  shield: { name: 'Pajzsmodul', description: '+40% pajzs, az energiasugár ellen erős; a kinetikus ágyú átüti.', costFactor: 1.1, tech: 'shield_matrix' },
  pointdef: { name: 'Pontvédelem', description: 'A rakéták sebzésének 60%-át lelövi; másra nem jó.', costFactor: 1.05, tech: 'point_defense' },
  ecm: { name: 'ECM', description: '+10% kitérés; a rakétákat 40%-kal gyengíti.', costFactor: 1.12, tech: 'ecm_suite' },
};

export const loadoutPriceFactor = (weapon: WeaponType, module: DefenseModule): number =>
  WEAPON_INFO[weapon].costFactor * MODULE_INFO[module].costFactor;
